const WEBHOOK_URL =
  (import.meta.env.VITE_QUIZ_WEBHOOK_URL as string | undefined) ||
  'https://primary-production-a3c48.up.railway.app/webhook/7efe1358-8adb-4edf-8cfe-67e2c5ac76a5';

export interface QuizPayload {
  submittedAt: string;
  contact: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    company: string;
    role: string;
  };
  answers: Record<string, string>;
  diagnosis: {
    industry: string;
    score?: number;
    outcome?: string;
    annualLeadLoss: number;
    wastedHours: number;
    savingsValue: number;
    insights: string[];
  };
  meta: {
    source: string;
    userAgent: string;
    referrer: string;
    pageUrl: string;
  };
}

export async function sendQuizPayload(payload: QuizPayload): Promise<boolean> {
  try {
    const res = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return res.ok;
  } catch {
    try {
      await fetch(WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
      });
      return true;
    } catch {
      return false;
    }
  }
}
